
import * as React from 'react';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { CategoryHotels } from '../core/CategoryHotels';
import { getHotelSlug, LOCAL_STORAGE_KEY_WISHLIST, makeid, FormatterUtils, BHAM_STORAGE_WISHLIST } from '../core/Const';
import { HotelBedData } from '../shared/index';
import { isNull, momentWrapper, momentDuration, getAjaxhelper } from '../utils/index';
export interface WishlistStorageData {
    code: string;
    user_id: number;
    name: string;
    description: string;
    filter: string;
    filterJson?: HotelBedData.SearchFilter;
    rowData: string;
    rowDataJson?: string[];
    status: string;

}

export interface WishListProps extends BaseComponentProps {
    lang: string;
    currency: string;
    wishlistCount: number;
}
export interface WishListState extends BaseComponentState {
    wishListBtn: any;
    data: WishlistStorageData | any;
}

export class WishList extends BaseComponent<WishListProps, WishListState> {

    constructor(props: WishListProps) {
        super(props);
        this.state = {
            wishListBtn: <span>Wish List <i className="ti-heart" /></span>,
            // wishListBtn: <i className="fa fa-heart" style={{ color: 'red' }} />,
            data: null
        };
    }

    componentDidUpdate(prevProps: WishListProps, prevState: WishListState) {
        if (prevProps.wishlistCount !== this.props.wishlistCount) {
            this.getdata();
        }
    }

    componentDidMount() {
        this.getdata();
    }

    getdata: () => any = () => {
        let a = localStorage.getItem(LOCAL_STORAGE_KEY_WISHLIST);
        if (!isNull(a)) {
            this.setStateHelper(st => {
                let data: WishlistStorageData = JSON.parse(a as string);
                data.rowDataJson = JSON.parse(data.rowData);
                data.filterJson = JSON.parse(data.filter);
                if (!isNull(data.rowDataJson) && data.rowDataJson!.length > 0) {
                    st.wishListBtn = <span style={{ color: 'red' }} >My Wish List <i className="fa fa-heart" /></span>;
                } else {
                    st.wishListBtn = <span>Wish List <i className="ti-heart" /></span>;
                }
                st.data = data;
            });
        }
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let whData: any[] = [];
        let listId = '';
        if (!isNull(this.state.data)) {
            listId = this.state.data.code;
            if (!isNull(this.state.data.rowDataJson) && this.state.data.rowDataJson.length === 0) {
                whData.push(
                    <li key={makeid()} >
                        <Link to="/hotels">You dont have WishList yet</Link>
                    </li>
                );
            } else {
                let j = 0;
                let night = 1;
                if (!isNull(this.state.data.filterJson)) {
                    let fr = momentWrapper(this.state.data.filterJson.stay.checkIn);
                    let to = momentWrapper(this.state.data.filterJson.stay.checkOut);
                    night = momentDuration(to.diff(fr)).as('day');
                }

                for (let i = this.state.data.rowDataJson.length - 1; i >= 0; i--) {
                    let hotel: HotelBedData.Hotel = JSON.parse(this.state.data.rowDataJson[i]);
                    whData.push(
                        <li key={makeid()} >
                            <Link to={`/${getHotelSlug(hotel.name!, hotel.code!)}`}>
                                <div style={{width: "90%", float: 'left'}}>
                                    <div style={{ backgroundSize: 'cover', float: 'left', width: 100, height: 75, marginRight: 15, backgroundImage: `url("${hotel.image}")` }} />
                                    <span style={{ fontSize: '1.2em', fontWeight: 800 }}>{hotel.name}</span>
                                    <CategoryHotels star={hotel.star!} />
                                    <p>{hotel.zoneName} <br />
                                        Start from {new FormatterUtils().formatMoney(hotel.minRate!, this.props.currency!, true, false)} for {night.toFixed(0)} Night</p>
                                </div>
                                <div style={{width: "10%", float: 'right'}}>
                                    <button 
                                        onClick={(evt) => { 
                                            evt.preventDefault();
                                            this.deleteWishlist(hotel);
                                        }} 
                                        className="btn btn-warning" 
                                        style={{}}
                                    >x
                                    </button>
                                </div>

                            </Link>

                        </li>
                    );
                    j++;
                    if (j === 5) {
                        break;
                    }
                }
            }

        } else {
            whData.push(
                <li key={makeid()} >
                    <Link to="/hotels">You dont have WishList yet</Link>
                </li>
            );
        }
        // let a = makeid();
        return (
            <li key={makeid()} className=" ">
                <a key={makeid()} data-toggle="dropdown" className="dropdown-toggle show-on-mobile">{this.state.wishListBtn} My WishList</a>
                <a key={makeid()} data-toggle="dropdown" className="dropdown-toggle show-on-desktop">{this.state.wishListBtn}</a>
                <ul key={makeid()} className="dropdown-menu wishlist" style={{ overflowX: 'hidden', overflowY: 'scroll', maxHeight: 'calc(100vh - 200px)' }}>
                    {whData}
                    <li><Link to={`/wishlist?id=${listId}`}> View my Wish List </Link></li>
                </ul>
            </li>
        );
    }
    
    deleteWishlist(hotel: HotelBedData.Hotel) {
        // alert(hotel.description);
        let wishlistID = sessionStorage.getItem(BHAM_STORAGE_WISHLIST) ? sessionStorage.getItem(BHAM_STORAGE_WISHLIST) : null;
        let whData: WishlistStorageData = this.state.data;
        let newRowData: string[] = [];
        whData.code = wishlistID!;
        for (let a of whData.rowDataJson!) {
            let h: HotelBedData.Hotel = JSON.parse(a);
            if (h.code !== hotel.code) {
                newRowData.push(a);
            }
        }
        whData.rowData = JSON.stringify(newRowData);
        getAjaxhelper().post("/dynamics/hb-api/cms-wishlist", whData).then(d => {
            localStorage.setItem(LOCAL_STORAGE_KEY_WISHLIST, JSON.stringify(whData));  
            sessionStorage.setItem(BHAM_STORAGE_WISHLIST, d.code );
            this.getdata();
        }).catch(exc => {
            console.log(exc);
        });
        
        //
    }

}


// WEBPACK FOOTER //
// ./src/header/WishList.tsx